import { Component, Inject } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { AdminService } from './admin.service';
import { CoreService } from '../core/core.service';
import { Main } from '../core/main.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
// import { Router } from '@angular/router';

@Component({
  selector: 'cp-notifications',
  templateUrl: './notifications.component.html',
})

export class NotificationsComponent {
  filter: string;
  typeFilter: string;
  statusFilter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;

  announcementsPerPage: number;
  totalAnnouncements: number;
  announcementsCurrentPage: number;

  notifications: any[];
  announcements: any[];
  notificationForm!: FormGroup;
  announcementForm!: FormGroup;
  selectedUser: any = {};
  ekubMembers: any = [];
  selectedEkub: any = {};
  ekubs: any = [];
  ekub: any;

  notification: any = {};
  announcement: any = {};

  constructor(private api: AdminService, @Inject(Restangular) public Restangular, private mainService: Main, private formBuilder: FormBuilder, private coreService: CoreService) {
    this.filter = '';
    this.statusFilter = '&status=';
    this.typeFilter = '&type=';
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;

    this.announcementsPerPage = 10;
    this.totalAnnouncements = 0;
    this.announcementsCurrentPage = 1;

    this.notifications = [];
    this.announcements = [];
    // this.getNotificationsFilter('unread,read');
    this.getNotificationsFilter();
  }

  ngOnInit() {
    this.createForm();
  }

  get user() { return this.notificationForm.get('user'); }
  get title() { return this.notificationForm.get('title'); }
  get content() { return this.notificationForm.get('content'); }
  get status() { return this.notificationForm.get('status'); }
  get type() { return this.notificationForm.get('type'); }

  get annoucementTitle() { return this.announcementForm.get('title'); }
  get annoucementMessage() { return this.announcementForm.get('message'); }
  get annoucementStatus() { return this.announcementForm.get('status'); }


  private createForm() {

    this.notificationForm = this.formBuilder.group({
      user: ['', [Validators.required,]],
      title: ['', [Validators.required,]],
      content: ['', [Validators.required,]],
      type: ['info', [Validators.required,]],
      status: ['unread', Validators.required],
    });

    this.announcementForm = this.formBuilder.group({
      title: ['', [Validators.required,]],
      message: ['', [Validators.required,]],
      status: ['active', Validators.required],
    });
  }

  getNotificationsFilter() {
    this.filter = this.typeFilter + this.statusFilter;
    this.getAllEkubs();
    this.getNotifications();
    this.getAnnouncements();
  }


  getAllEkubs() {
    debugger;
    this.api.getAllEkubs('?status=active').subscribe((res: any) => {
      debugger;
      this.ekubs = res.data;
      for (let ekub of this.ekubs) {
        //ekub.text = ekub.ekub_id;
        ekub.text = ekub.ekub_id + ' ' + ekub.category.data.title + ':' + ekub.category.data.amount + '/' + ekub.category.data.interval;
        ekub.id = ekub.id;
      }
    });
  }

  getEkubMembers(ekubId: any = null) {
    debugger;
    this.api.getEkubMembers(ekubId).subscribe((res: any) => {
      debugger;
      if (res.data) {
        this.ekubMembers = res.data;
        for (let member of this.ekubMembers) {
          member.text = member.username;
          member.id = member.id;
        }
      }
    });
  }

  getNotifications() {

    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getNotifications(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.notifications = resp.data;
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    });
  }

  getAnnouncements() {

    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getAnnouncements(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.announcements = resp.data;
      this.totalAnnouncements = resp.meta.pagination.total;
      this.announcementsPerPage = resp.meta.pagination.per_page;
    });
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getNotifications();
  }


  changeStatus(id: any, status: any) {
    this.api.changeNotificationStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getNotifications();
    }, (err) => {
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  changeAnnouncementStatus(id: any, status: any) {
    this.api.changeAnnouncementStatus(id, status).subscribe((res: any) => {
      this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
      this.getAnnouncements();
    }, (err) => {
      //this.coreService.addToast('Error', err.statusText);
    });
  }

  announcementPageChanged(event: any) {
    event = event;
    this.announcementsCurrentPage = this.announcementsCurrentPage;
    this.getAnnouncements();
  }

  addNotification(id: string) {
    debugger;
    //this.isLoading = !this.isLoading;
    this.notification = this.notificationForm.value;
    this.api.createNotification(this.notification, id).subscribe((res: any) => {
      debugger;
      //this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Success', body: (id) ? 'Notification successfully updated! ' : 'Notification  successfully added!', type: 'dark' });
      this.getNotifications();
    }, (err) => {
      err = err;
      //this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Success', body: (id) ? 'Could not updaten otification!' : 'Could not add notification!', type: 'danger' });
    });
  }

  addAnnouncement(id: string) {
    debugger;
    //this.isLoading = !this.isLoading;
    this.announcement = this.announcementForm.value;
    this.api.createAnnouncement(this.announcement, id).subscribe((res: any) => {
      debugger;
      //this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Success', body: (id) ? 'Announcement successfully updated! ' : 'Announcement  successfully added!', type: 'dark' });
      this.getAnnouncements();
    }, (err) => {
      err = err;
      //this.isLoading = !this.isLoading;
      this.mainService.toast({ title: 'Success', body: (id) ? 'Could not update announcement!' : 'Could not add announcement!', type: 'danger' });
    });
  }

  setNotification(notification: any) {
    debugger;
    this.notification = notification;
    this.title.setValue(notification.title);
    this.content.setValue(notification.content);
    this.type.setValue(notification.type);
    this.status.setValue(notification.status);
    document.getElementById('openNotificationModal').click();
  }

  setAnnouncement(annoucement: any) {
    debugger;
    this.announcement = annoucement;
    this.annoucementTitle.setValue(annoucement.title);
    this.annoucementMessage.setValue(annoucement.message);
    this.annoucementStatus.setValue(annoucement.status);
    document.getElementById('openAnnouncementModal').click();
  }

}
